import React from "react";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Legend,
  Tooltip,
} from "recharts";
import { useMediaQuery, useTheme } from "@material-ui/core";

const COLORS = [
  "#b28345",
  "#846bb2",
  "#b28394",
  "#b26b94",
  "#6b94b2",
  "#6b84b2",
  "#b29a6b",
  "#6bb284",
];

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
  const radius = outerRadius + 20;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="#333"
      textAnchor={x > cx ? "start" : "end"}
      dominantBaseline="central"
      style={{ fontSize: "14px", fontWeight: "bold" }}
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const currentEntry = payload[0].payload;
    if (currentEntry.name === "Others") {
      return (
        <div style={{ backgroundColor: "#fff", padding: "5px", border: "1px solid #ccc" }}>
          <p style={{ margin: 0, fontWeight: "bold" }}>Others</p>
          <ul style={{ margin: 0, paddingLeft: "15px" }}>
            {currentEntry.others.map((item, idx) => (
              <li key={idx}>{`${item.name}: ${item.count}`}</li>
            ))}
          </ul>
        </div>
      );
    }
    return (
      <div style={{ backgroundColor: "#fff", padding: "5px", border: "1px solid #ccc" }}>
        <p style={{ margin: 0 }}>{`${currentEntry.name} : ${currentEntry.count}`}</p>
      </div>
    );
  }
  return null;
};

const CustomPieChart = ({ dataPassed, keyPassed }) => {
  const theme = useTheme();
  const isSmallResolution = useMediaQuery(theme.breakpoints.down("md"));

  const total = dataPassed.reduce((sum, entry) => sum + entry[keyPassed], 0);

  let smallSlices = [];
  const groupedData = dataPassed.reduce((acc, entry) => {
    const percentage = (entry[keyPassed] / total) * 100;
    if (percentage > 1) {
      acc.push(entry);
    } else {
      smallSlices.push(entry);
    }
    return acc;
  }, []);

  if (smallSlices.length > 0) {
    const othersTotal = smallSlices.reduce((sum, entry) => sum + entry[keyPassed], 0);
    groupedData.push({
      name: "Others",
      count: othersTotal,
      others: smallSlices, // Attach grouped entries for the tooltip
    });
  }

  return (
    <ResponsiveContainer width="100%" height="100%">
      <PieChart>
        <Pie
          data={groupedData}
          cx="50%"
          cy="50%"
          labelLine={true}
          label={renderCustomizedLabel}
          startAngle={0}
          endAngle={360}
          outerRadius={120}
          innerRadius={40}
          dataKey={keyPassed}
          minAngle={2}
        >
          {groupedData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Legend
          layout={isSmallResolution ? "horizontal" : "vertical"}
          align={isSmallResolution ? "left" : "right"}
          verticalAlign={isSmallResolution ? "bottom" : "middle"}
          iconSize={10}
          iconType="circle"
        />
        <Tooltip content={<CustomTooltip />} />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default CustomPieChart;
